import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@actioncenter/"

const loadPlaceholdersObjs = makePieActionObjs("load", "placeholders")
export const loadPlaceholdersActionDict = loadPlaceholdersObjs.pieDict

const validatePlaceholdersObjs = makePieActionObjs("validate", "placeholders")
export const validatePlaceholdersActionDict = validatePlaceholdersObjs.pieDict

const loadGrassrootsRegistrationPageObjs = makePieActionObjs("load", "grassroots_registration_page")
export const loadGrassrootsRegistrationPageActionDict = loadGrassrootsRegistrationPageObjs.pieDict

const patchGrassrootsRegistrationPageObjs = makePieActionObjs("patch", "grassroots_registration_page")
export const patchGrassrootsRegistrationPageActionDict = patchGrassrootsRegistrationPageObjs.pieDict

const createGrassrootsRegistrationPageObjs = makePieActionObjs("create", "grassroots_registration_page")
export const createGrassrootsRegistrationPageActionDict = createGrassrootsRegistrationPageObjs.pieDict

const patchCampaignInteractionTypesObjs = makePieActionObjs("patch", "campaign_interaction_types")
export const patchCampaignInteractionTypesActionDict = patchCampaignInteractionTypesObjs.pieDict

const validateRegulationIdObjs = makePieActionObjs("validate", "campaign_regulation_id")
export const validateRegulationIdActionDict = validateRegulationIdObjs.pieDict

const _CampaignActionTypes = {
    LOAD_CAMPAIGN_START: "LOAD_CAMPAIGN_START",
    LOAD_CAMPAIGN_SUCCESS: "LOAD_CAMPAIGN_SUCCESS",
    LOAD_CAMPAIGN_FAIL: "LOAD_CAMPAIGN_FAIL",

    CREATE_DEFAULT_SAVED_SEARCH_START: "CREATE_DEFAULT_SAVED_SEARCH_START",
    CREATE_DEFAULT_SAVED_SEARCH_SUCCESS: "CREATE_DEFAULT_SAVED_SEARCH_SUCCESS",
    CREATE_DEFAULT_SAVED_SEARCH_FAIL: "CREATE_DEFAULT_SAVED_SEARCH_FAIL",

    EDIT_CAMPAIGN: "EDIT_CAMPAIGN",
    UPDATE_CAMPAIGN_STORE: "UPDATE_CAMPAIGN_STORE",

    PATCH_CAMPAIGN_START: "PATCH_CAMPAIGN_START",
    PATCH_CAMPAIGN_SUCCESS: "PATCH_CAMPAIGN_SUCCESS",
    PATCH_CAMPAIGN_FAIL: "PATCH_CAMPAIGN_FAIL",

    PATCH_SAVED_SEARCH_START: "PATCH_SAVED_SEARCH_START",
    PATCH_SAVED_SEARCH_SUCCESS: "PATCH_SAVED_SEARCH_SUCCESS",
    PATCH_SAVED_SEARCH_FAIL: "PATCH_SAVED_SEARCH_FAIL",

    START_ADV_SELECTION: "START_ADV_SELECTION",
    ADD_ADV_SELECTION: "ADD_ADV_SELECTION",
    CAMPAIGN_SUBMIT_SEARCHIFY: "CAMPAIGN_SUBMIT_SEARCHIFY",

    ADD_TWEET_VALUE: "ADD_TWEET_VALUE",
    UPDATE_TWEET_VALUE: "UPDATE_TWEET_VALUE",
    DELETE_TWEET_VALUE: "DELETE_TWEET_VALUE",

    PETITION_DOWNLOAD_DOC_START: "PETITION_DOWNLOAD_DOC_START",
    PETITION_DOWNLOAD_DOC_SUCCESS: "PETITION_DOWNLOAD_DOC_SUCCESS",
    PETITION_DOWNLOAD_DOC_FAIL: "PETITION_DOWNLOAD_DOC_FAIL",

    PARTICIPANT_DOWNLOAD_CSV_START: "PARTICIPANT_DOWNLOAD_CSV_START",
    PARTICIPANT_DOWNLOAD_CSV_SUCCESS: "PARTICIPANT_DOWNLOAD_CSV_SUCCESS",
    PARTICIPANT_DOWNLOAD_CSV_FAIL: "PARTICIPANT_DOWNLOAD_CSV_FAIL",

    CLEAR_GRASSROOTS_REGISTRATION_PAGE: "CLEAR_GRASSROOTS_REGISTRATION_PAGE",

    SET_VALID: "SET_VALID",

    ...loadPlaceholdersObjs.actionTypes,
    ...validatePlaceholdersObjs.actionTypes,
    ...loadGrassrootsRegistrationPageObjs.actionTypes,
    ...patchGrassrootsRegistrationPageObjs.actionTypes,
    ...createGrassrootsRegistrationPageObjs.actionTypes,
    ...validateRegulationIdObjs.actionTypes,
}

const CampaignActionTypes = prependAppName(appName, _CampaignActionTypes)

export const loadCampaignTypes = {
    start: CampaignActionTypes.LOAD_CAMPAIGN_START,
    success: CampaignActionTypes.LOAD_CAMPAIGN_SUCCESS,
    fail: CampaignActionTypes.LOAD_CAMPAIGN_FAIL,
}

export const patchCampaignTypes = {
    start: CampaignActionTypes.PATCH_CAMPAIGN_START,
    success: CampaignActionTypes.PATCH_CAMPAIGN_SUCCESS,
    fail: CampaignActionTypes.PATCH_CAMPAIGN_FAIL,
}

export const downloadPetitionWordDocTypes = {
    start: CampaignActionTypes.PETITION_DOWNLOAD_DOC_START,
    success: CampaignActionTypes.PETITION_DOWNLOAD_DOC_SUCCESS,
    fail: CampaignActionTypes.PETITION_DOWNLOAD_DOC_FAIL,
}

export const participantDownloadTypes = {
    start: CampaignActionTypes.PARTICIPANT_DOWNLOAD_CSV_START,
    success: CampaignActionTypes.PARTICIPANT_DOWNLOAD_CSV_SUCCESS,
    fail: CampaignActionTypes.PARTICIPANT_DOWNLOAD_CSV_FAIL,
}

export default CampaignActionTypes
